import type { SavedCard } from '../types';

const BRAND_NAMES: Record<string, string> = {
  visa: 'Visa',
  mc: 'Mastercard',
  mastercard: 'Mastercard',
  amex: 'American Express',
  maestro: 'Maestro',
  discover: 'Discover',
};

const ACTIVE = 'ACTIVE';

// `fallback` is the translated word for "card", shown when the card names no brand.
export const cardBrand = (card: SavedCard, fallback = '') => {
  const brand = (card.brand || card.type || fallback).trim();
  return BRAND_NAMES[brand.toLowerCase()] ?? brand.charAt(0).toUpperCase() + brand.slice(1);
};

export const cardLabel = (card: SavedCard, fallback = '') =>
  card.lastFour ? `${cardBrand(card, fallback)} ...${card.lastFour}` : cardBrand(card, fallback);

export const cardExpiry = (card: SavedCard) =>
  card.expiryMonth && card.expiryYear
    ? `${card.expiryMonth.padStart(2, '0')}/${card.expiryYear.slice(-2)}`
    : '';

/** The expiry with the full year, such as "08 / 2028". */
export const cardExpiryLong = (card: SavedCard) => {
  if (!card.expiryMonth || !card.expiryYear) return '';
  const year = card.expiryYear.length === 2 ? `20${card.expiryYear}` : card.expiryYear;
  return `${card.expiryMonth.padStart(2, '0')} / ${year}`;
};

/** A card works until the end of its expiry month. */
export const isCardExpired = (card: SavedCard, now = new Date()) => {
  const month = Number(card.expiryMonth);
  const year = Number(card.expiryYear);
  if (!month || !year) return false;
  const fullYear = year < 100 ? 2000 + year : year;
  return new Date(fullYear, month, 1) <= now;
};

export const usableCards = (cards: SavedCard[] = []) =>
  cards.filter((card) => card.status === ACTIVE && !isCardExpired(card));
